import axios from 'axios'
import { baseUrl,miniId } from './apiUrl'

export default function request(reqObj){
    let req = reqObj;
    let url =baseUrl.prod+req.url;
    let data =req.data?req.data:{};
    if(!data.noMiniId){
        data.miniId=miniId
    }
    let method =req.method?req.method:'GET';
    return new Promise((resolve,reject)=>{
        let promise;
        if(method == 'GET'){
            promise = axios.get(url,{params:data});
        }else{
            promise = axios.post(url,data);
        }
        promise.then(res=>{
            resolve(res.data);
        }).catch(err=>{
           reject(err)
        })
    })
}




// WEBPACK FOOTER //
// ./src/utils/request.js